import React, { useState } from 'react';
import { 
  Typography, 
  TextField, 
  Button, 
  Box,
  Paper,
  CircularProgress,
  Container,
  List,
  ListItem,
  ListItemText,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';

const GoalWritingAssistant = () => {
  const [clientInfo, setClientInfo] = useState('');
  const [goalType, setGoalType] = useState('');
  const [generatedGoals, setGeneratedGoals] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const generateGoals = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch('/api/generateABAGoals', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ clientInfo, goalType }),
      });
      if (!response.ok) {
        throw new Error('Failed to generate goals');
      }
      const data = await response.json();
      if (Array.isArray(data.goals)) {
        setGeneratedGoals(data.goals);
      } else {
        throw new Error('Received invalid data format');
      }
    } catch (error) {
      console.error('Error generating goals:', error);
      setError('Failed to generate goals. Please try again.');
    }
    setLoading(false);
  };

  return (
    <Container maxWidth="md">
      <Paper elevation={0} sx={{ p: 4, backgroundColor: 'white' }}>
        <Box sx={{ mb: 4 }}>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Goal Type</InputLabel>
            <Select
              value={goalType}
              label="Goal Type"
              onChange={(e) => setGoalType(e.target.value)}
            >
              <MenuItem value="parent_training">Parent Training</MenuItem>
              <MenuItem value="learner">Learner</MenuItem>
              <MenuItem value="social_skills">Social Skills</MenuItem>
              <MenuItem value="communication">Communication</MenuItem>
              <MenuItem value="behavior_reduction">Behavior Reduction</MenuItem>
            </Select>
          </FormControl>
          <TextField
            fullWidth
            multiline
            rows={4}
            value={clientInfo}
            onChange={(e) => setClientInfo(e.target.value)}
            placeholder="Enter context for the goal, client information, current skill levels, and areas of need..."
            variant="outlined"
            sx={{ mb: 2 }}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={generateGoals}
            disabled={loading || !clientInfo || !goalType}
          >
            Generate Goals
          </Button>
        </Box>
        {loading && <CircularProgress />}
        {error && (
          <Typography color="error" sx={{ mt: 2 }}>
            {error}
          </Typography>
        )}
        {generatedGoals.length > 0 && (
          <Box>
            <Typography variant="h6" gutterBottom>
              Generated Goals:
            </Typography>
            <List>
              {generatedGoals.map((goal, index) => (
                <React.Fragment key={index}>
                  <ListItem alignItems="flex-start">
                    <ListItemText
                      primary={goal.goalStatement || 'Goal Statement Not Available'}
                      secondary={
                        <>
                          <Typography
                            component="span"
                            variant="body2"
                            color="text.primary"
                          >
                            Objective: 
                          </Typography>
                          {" " + (goal.objective || 'Not Available')}
                          <br />
                          <Typography
                            component="span"
                            variant="body2"
                            color="text.primary"
                          >
                            Measurement: 
                          </Typography>
                          {" " + (goal.measurement || 'Not Available')}
                        </>
                      }
                    />
                  </ListItem>
                  {index < generatedGoals.length - 1 && <Divider />}
                </React.Fragment>
              ))}
            </List>
          </Box>
        )}
      </Paper>
    </Container>
  );
};

export default GoalWritingAssistant;